import { render } from "./DocumentCategories.vue?vue&type=template&id=1b9defa5&ts=true"
import script from "./DocumentCategories.vue?vue&type=script&lang=ts"
export * from "./DocumentCategories.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kanbios/echo-v2/demo-front-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__